import isEmpty from 'lodash/isEmpty';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();

const formatString = (input, fromFormat = 'E164', toFormat = PhoneNumberFormat.NATIONAL) => {
    if (isEmpty(input)) {
        return null;
    }

    const parsed = phoneUtil.parse(input, fromFormat);

    return phoneUtil.format(parsed, toFormat);
};

export {
    formatString
};

export default {
    formatString: formatString
};
